"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Product_API_PATH = exports.ProductPath = void 0;
const product = "/product";
exports.ProductPath = {
    product,
};
const api_prefix = "api";
const handlePath = ({ path }) => {
    const apiPath = {
        frontend: `${api_prefix}${exports.ProductPath.product}/${path}`,
        backend: `/${path}`,
    };
    return apiPath;
};
exports.Product_API_PATH = {
    new: handlePath({
        path: `new`,
    }),
    getProducts: handlePath({
        path: `/`,
    }),
    getProduct: (id) => handlePath({
        path: `/${id}`,
    }),
    quotaById: (id) => handlePath({
        path: `/quota/${id}`,
    }),
};
//# sourceMappingURL=product.js.map